import igIcon from './index.vue'
export default {
    install: function (Vue) {
        Vue.component('ig-icon', igIcon)
    }
}
